var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import createRestClient from '../rest/RestClient';
import Config from '../../config/config';
const getEmailVerificationStatus = (techSmithId) => __awaiter(void 0, void 0, void 0, function* () {
    const url = new URL('/api/v1/user/emailverificationstatus', Config.helperServiceBaseUrl);
    url.searchParams.append('techSmithId', techSmithId);
    const restClient = createRestClient(url.href);
    const response = yield restClient.get({ url: '' });
    return response.body;
});
export default getEmailVerificationStatus;
